/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: UZhBi-wdivTm

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import FeaturesProductHeader from "../../FeaturesProductHeader"; // plasmic-import: nCl4kJqd_uCB/component
import Logo from "../../Logo"; // plasmic-import: 2Sac1UHK8925/component
import FeaturesCard from "../../FeaturesCard"; // plasmic-import: eBFTaYn0ldI-/component
import ListItem from "../../ListItem"; // plasmic-import: vpKD71-ztgZQ/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicFeaturesMyGme.module.css"; // plasmic-import: UZhBi-wdivTm/css

import Icon5Icon from "./icons/PlasmicIcon__Icon5"; // plasmic-import: z8Bk5fXmTx-P/icon

createPlasmicElementProxy;

export type PlasmicFeaturesMyGme__VariantMembers = {};
export type PlasmicFeaturesMyGme__VariantsArgs = {};
type VariantPropType = keyof PlasmicFeaturesMyGme__VariantsArgs;
export const PlasmicFeaturesMyGme__VariantProps = new Array<VariantPropType>();

export type PlasmicFeaturesMyGme__ArgsType = {};
type ArgPropType = keyof PlasmicFeaturesMyGme__ArgsType;
export const PlasmicFeaturesMyGme__ArgProps = new Array<ArgPropType>();

export type PlasmicFeaturesMyGme__OverridesType = {
  myEvaluations?: Flex__<"section">;
  desktop?: Flex__<"div">;
  row?: Flex__<"div">;
  key2?: Flex__<"div">;
  header?: Flex__<"header">;
  list7?: Flex__<"div">;
  row5?: Flex__<"div">;
  row9?: Flex__<"div">;
  row10?: Flex__<"div">;
  all?: Flex__<"div">;
  title?: Flex__<"h2">;
  sections?: Flex__<"div">;
  col2?: Flex__<"div">;
  list2?: Flex__<"div">;
  tablet?: Flex__<"div">;
  row6?: Flex__<"div">;
  key4?: Flex__<"div">;
  header4?: Flex__<"header">;
  list11?: Flex__<"div">;
  row7?: Flex__<"div">;
  row8?: Flex__<"div">;
  row11?: Flex__<"div">;
  row12?: Flex__<"div">;
  all3?: Flex__<"div">;
  title3?: Flex__<"h2">;
  sections2?: Flex__<"div">;
  col3?: Flex__<"div">;
  list4?: Flex__<"div">;
  mobile?: Flex__<"div">;
  header3?: Flex__<"div">;
  key3?: Flex__<"div">;
  header2?: Flex__<"header">;
  list6?: Flex__<"div">;
  all2?: Flex__<"div">;
  title2?: Flex__<"h2">;
  sections3?: Flex__<"div">;
  col4?: Flex__<"div">;
  list3?: Flex__<"div">;
};

export interface DefaultFeaturesMyGmeProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFeaturesMyGme__RenderFunc(props: {
  variants: PlasmicFeaturesMyGme__VariantsArgs;
  args: PlasmicFeaturesMyGme__ArgsType;
  overrides: PlasmicFeaturesMyGme__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"myEvaluations"}
      data-plasmic-override={overrides.myEvaluations}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.myEvaluations
      )}
      id={"MyGME"}
    >
      {(hasVariant(globalVariants, "mobile", "mobile") ? false : true) ? (
        <PlasmicImg__
          alt={""}
          className={classNames(sty.img___9POVn)}
          displayHeight={"527px"}
          displayMaxHeight={"none"}
          displayMaxWidth={"none"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"1770px"}
          loader={"plasmic"}
          loading={"lazy"}
          src={{
            src: "https://site-assets.plasmic.app/67f04ddfb024c31590f097503108861e.svg",
            fullWidth: 1770,
            fullHeight: 527,
            aspectRatio: 3.358634
          }}
        />
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? false
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? false
            : true
      ) ? (
        <div
          data-plasmic-name={"desktop"}
          data-plasmic-override={overrides.desktop}
          className={classNames(projectcss.all, sty.desktop)}
        >
          <div
            data-plasmic-name={"row"}
            data-plasmic-override={overrides.row}
            className={classNames(projectcss.all, sty.row)}
          >
            <FeaturesProductHeader
              className={classNames(
                "__wab_instance",
                sty.featuresProductHeader___7Rpxq
              )}
              description={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
                  : "MyGME Fiscal uses MyEvaluations data for precise fiscal management, including Medicare reimbursements. Features: Rotation Schedules, Gap Analysis, detailed reports for accurate submissions."
              }
              subtitle={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "Product"
                  : "Product"
              }
            >
              <Logo
                className={classNames("__wab_instance", sty.logo__alngc)}
                product={"myGme"}
              />
            </FeaturesProductHeader>
          </div>
          <div
            data-plasmic-name={"key2"}
            data-plasmic-override={overrides.key2}
            className={classNames(projectcss.all, sty.key2)}
          >
            <header
              data-plasmic-name={"header"}
              data-plasmic-override={overrides.header}
              className={classNames(projectcss.all, sty.header)}
            >
              <h2
                className={classNames(
                  projectcss.all,
                  projectcss.h2,
                  projectcss.__wab_text,
                  sty.h2__fFdiH
                )}
              >
                {"Key Features"}
              </h2>
            </header>
            <div
              data-plasmic-name={"list7"}
              data-plasmic-override={overrides.list7}
              className={classNames(projectcss.all, sty.list7)}
            >
              <div
                data-plasmic-name={"row5"}
                data-plasmic-override={overrides.row5}
                className={classNames(projectcss.all, sty.row5)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__ry66P
                  )}
                  desciption={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "Leverage our Reimbursement Dashboard and guided workflows for streamlined fiscal management. Stay financially prepared with ease."
                      : "Leverage our Reimbursement Dashboard and guided workflows for streamlined fiscal management. Stay financially prepared with ease."
                  }
                  title={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "Reimbursement & Cost Reporting"
                      : "Reimbursement & Cost Reporting"
                  }
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__e1NwB)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={
                      hasVariant(globalVariants, "mobile", "tabletLandscape")
                        ? {
                            src: "https://img.plasmic.app/img-optimizer/v1/img/41f0116005941f98fd7ef65b5ee7e865.png",
                            fullWidth: 747,
                            fullHeight: 478
                          }
                        : {
                            src: "https://img.plasmic.app/img-optimizer/v1/img/41f0116005941f98fd7ef65b5ee7e865.png",
                            fullWidth: 747,
                            fullHeight: 478
                          }
                    }
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__nSip7
                  )}
                  desciption={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "Streamline reporting processes, ensuring compliance with industry standards. Access tools for precise program assessment and outcome refinement."
                      : "Streamline reporting processes, ensuring compliance with industry standards. Access tools for precise program assessment and outcome refinement."
                  }
                  title={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "IRIS/STAR Export"
                      : "IRIS/STAR Export"
                  }
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__oSYh)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={
                      hasVariant(globalVariants, "mobile", "tabletLandscape")
                        ? {
                            src: "https://site-assets.plasmic.app/27869c919c0c1bf802d79c76d1aaf6b6.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                        : {
                            src: "https://site-assets.plasmic.app/27869c919c0c1bf802d79c76d1aaf6b6.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                    }
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__jnFlJ
                  )}
                  desciption={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "Effortlessly generate customized invoices for rotations and services. Simplify program-related expense and revenue management. Ensure transparent financial dealings with stakeholders."
                      : "Effortlessly generate customized invoices for rotations and services. Simplify program-related expense and revenue management. Ensure transparent financial dealings with stakeholders."
                  }
                  title={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "Billing & Invoicing"
                      : "Billing & Invoicing"
                  }
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__w5X7K)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={
                      hasVariant(globalVariants, "mobile", "tabletLandscape")
                        ? {
                            src: "https://site-assets.plasmic.app/4ab181866ee0f60493ae5d373a9044df.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                        : {
                            src: "https://site-assets.plasmic.app/4ab181866ee0f60493ae5d373a9044df.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                    }
                  />
                </FeaturesCard>
              </div>
              <div
                data-plasmic-name={"row9"}
                data-plasmic-override={overrides.row9}
                className={classNames(projectcss.all, sty.row9)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__g0MFs
                  )}
                  desciption={
                    "Compare available to actual FTE to improve your bottom line. Support strategic planning for future expansions or contractions. Aid in balancing workload and assignments based on capacity and utilization. "
                  }
                  title={"FTE Reports & CAP Analysis"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__qmmb4)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/545cfd43ea0c899d900f2bf946291cf3.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__uu09J
                  )}
                  desciption={
                    "Ensure compliance by automating audit trails with integrated schedule details. Streamline the audit process and compliance checks. Reduce manual effort and support program transparency."
                  }
                  title={"Audit Management"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__nhAjy)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/7e7f7eb8cfd3c607aabaf3c6aef207b6.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__bwFZy
                  )}
                  desciption={
                    "Simplify personal data import from MyEvaluations, ensuring integrity and avoiding costly mistakes. Securely manage staff and trainee information for complete audit readiness."
                  }
                  title={"Errors & Omissions Analysis"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___4YnRm)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/a322737f1ec651e50fcaee6b41573d02.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </div>
              <div
                data-plasmic-name={"row10"}
                data-plasmic-override={overrides.row10}
                className={classNames(projectcss.all, sty.row10)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__sIzPg
                  )}
                  desciption={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "MyQuickPass integration combines geofencing with MyGME Fiscal for accurate trainee activity records. Automatically log clinical hours to ensure accurate data for rigorous Medicare audits."
                      : "MyQuickPass integration combines geofencing with MyGME Fiscal for accurate trainee activity records. Automatically log clinical hours to ensure accurate data for rigorous Medicare audits."
                  }
                  title={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "MyQuickPass Integration"
                      : "MyQuickPass Integration"
                  }
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___5OKpU)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={
                      hasVariant(globalVariants, "mobile", "tabletLandscape")
                        ? {
                            src: "https://site-assets.plasmic.app/2890f4b1e6e8039548a72a55921e66f2.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                        : {
                            src: "https://site-assets.plasmic.app/2890f4b1e6e8039548a72a55921e66f2.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                    }
                  />
                </FeaturesCard>
                <div
                  className={classNames(projectcss.all, sty.freeBox__yQldc)}
                />

                <div
                  className={classNames(projectcss.all, sty.freeBox__ccjA)}
                />
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"all"}
            data-plasmic-override={overrides.all}
            className={classNames(projectcss.all, sty.all)}
          >
            <h2
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames(
                projectcss.all,
                projectcss.h2,
                projectcss.__wab_text,
                sty.title
              )}
            >
              {"Full Feature List"}
            </h2>
            <div
              data-plasmic-name={"sections"}
              data-plasmic-override={overrides.sections}
              className={classNames(projectcss.all, sty.sections)}
            >
              <div
                data-plasmic-name={"col2"}
                data-plasmic-override={overrides.col2}
                className={classNames(projectcss.all, sty.col2)}
              >
                <div
                  data-plasmic-name={"list2"}
                  data-plasmic-override={overrides.list2}
                  className={classNames(projectcss.all, sty.list2)}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return [
                          {
                            text: "Billing & Invoicing"
                          },
                          {
                            text: "IRIS/STAR Export"
                          },
                          {
                            text: "Gap and Overlap Analysis"
                          },
                          {
                            text: "FTE Reports & CAP Analysis"
                          },
                          {
                            text: "Audit Management"
                          },
                          {
                            text: "Errors & Omissions Analysis"
                          },
                          {
                            text: "MyQuickPass Integration"
                          }
                        ];
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const currentItem = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <ListItem
                        className={classNames(
                          "__wab_instance",
                          sty.listItem___59ZKm
                        )}
                        key={currentIndex}
                        text={(() => {
                          try {
                            return currentItem.text;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <Icon5Icon
                          className={classNames(projectcss.all, sty.svg__qjoSx)}
                          role={"img"}
                        />
                      </ListItem>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? false
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? true
            : false
      ) ? (
        <div
          data-plasmic-name={"tablet"}
          data-plasmic-override={overrides.tablet}
          className={classNames(projectcss.all, sty.tablet)}
        >
          <div
            data-plasmic-name={"row6"}
            data-plasmic-override={overrides.row6}
            className={classNames(projectcss.all, sty.row6)}
          >
            <FeaturesProductHeader
              className={classNames(
                "__wab_instance",
                sty.featuresProductHeader___25K2Y
              )}
              description={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
                  : "MyGME Fiscal uses MyEvaluations data for precise fiscal management, including Medicare reimbursements. Features: Rotation Schedules, Gap Analysis, detailed reports for accurate submissions."
              }
              subtitle={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "Product"
                  : "Product"
              }
            >
              <Logo
                className={classNames("__wab_instance", sty.logo__ua5X6)}
                product={"myGme"}
              />
            </FeaturesProductHeader>
          </div>
          <div
            data-plasmic-name={"key4"}
            data-plasmic-override={overrides.key4}
            className={classNames(projectcss.all, sty.key4)}
          >
            <header
              data-plasmic-name={"header4"}
              data-plasmic-override={overrides.header4}
              className={classNames(projectcss.all, sty.header4)}
            >
              <h2
                className={classNames(
                  projectcss.all,
                  projectcss.h2,
                  projectcss.__wab_text,
                  sty.h2__xJcJt
                )}
              >
                {"Key Features"}
              </h2>
            </header>
            <div
              data-plasmic-name={"list11"}
              data-plasmic-override={overrides.list11}
              className={classNames(projectcss.all, sty.list11)}
            >
              <div
                data-plasmic-name={"row7"}
                data-plasmic-override={overrides.row7}
                className={classNames(projectcss.all, sty.row7)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__sOpi
                  )}
                  desciption={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "Leverage our Reimbursement Dashboard and guided workflows for streamlined fiscal management. Stay financially prepared with ease."
                      : "Leverage our Reimbursement Dashboard and guided workflows for streamlined fiscal management. Stay financially prepared with ease."
                  }
                  title={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "Reimbursement & Cost Reporting"
                      : "Reimbursement & Cost Reporting"
                  }
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__s9Afo)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={
                      hasVariant(globalVariants, "mobile", "tabletPortrait")
                        ? {
                            src: "https://img.plasmic.app/img-optimizer/v1/img/41f0116005941f98fd7ef65b5ee7e865.png",
                            fullWidth: 747,
                            fullHeight: 478
                          }
                        : hasVariant(
                              globalVariants,
                              "mobile",
                              "tabletLandscape"
                            )
                          ? {
                              src: "https://site-assets.plasmic.app/f079f25afd226b7eaf59969b4e8413d0.svg",
                              fullWidth: 374,
                              fullHeight: 239,
                              aspectRatio: 1.564854
                            }
                          : {
                              src: "https://site-assets.plasmic.app/f079f25afd226b7eaf59969b4e8413d0.svg",
                              fullWidth: 374,
                              fullHeight: 239,
                              aspectRatio: 1.564854
                            }
                    }
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__gfcXr
                  )}
                  desciption={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "Streamline reporting processes, ensuring compliance with industry standards. Access tools for precise program assessment and outcome refinement."
                      : "Streamline reporting processes, ensuring compliance with industry standards. Access tools for precise program assessment and outcome refinement."
                  }
                  title={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "IRIS/STAR Export"
                      : "IRIS/STAR Export"
                  }
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__qxEqC)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={
                      hasVariant(globalVariants, "mobile", "tabletLandscape")
                        ? {
                            src: "https://site-assets.plasmic.app/27869c919c0c1bf802d79c76d1aaf6b6.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                        : {
                            src: "https://site-assets.plasmic.app/27869c919c0c1bf802d79c76d1aaf6b6.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                    }
                  />
                </FeaturesCard>
              </div>
              <div
                data-plasmic-name={"row8"}
                data-plasmic-override={overrides.row8}
                className={classNames(projectcss.all, sty.row8)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__fszWh
                  )}
                  desciption={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "Effortlessly generate customized invoices for rotations and services. Simplify program-related expense and revenue management. Ensure transparent financial dealings with stakeholders."
                      : "Effortlessly generate customized invoices for rotations and services. Simplify program-related expense and revenue management. Ensure transparent financial dealings with stakeholders."
                  }
                  title={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "Billing & Invoicing"
                      : "Billing & Invoicing"
                  }
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__ceYrC)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={
                      hasVariant(globalVariants, "mobile", "tabletLandscape")
                        ? {
                            src: "https://site-assets.plasmic.app/4ab181866ee0f60493ae5d373a9044df.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                        : {
                            src: "https://site-assets.plasmic.app/4ab181866ee0f60493ae5d373a9044df.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                    }
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__vU6E1
                  )}
                  desciption={
                    "Compare available to actual FTE to improve your bottom line. Support strategic planning for future expansions or contractions. Aid in balancing workload and assignments based on capacity and utilization. "
                  }
                  title={"FTE Reports & CAP Analysis"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___6XVwM)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/545cfd43ea0c899d900f2bf946291cf3.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </div>
              <div
                data-plasmic-name={"row11"}
                data-plasmic-override={overrides.row11}
                className={classNames(projectcss.all, sty.row11)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__ig9AJ
                  )}
                  desciption={
                    "Ensure compliance by automating audit trails with integrated schedule details. Streamline the audit process and compliance checks. Reduce manual effort and support program transparency."
                  }
                  title={"Audit Management"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__rhlDw)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/7e7f7eb8cfd3c607aabaf3c6aef207b6.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__eatYl
                  )}
                  desciption={
                    "Simplify personal data import from MyEvaluations, ensuring integrity and avoiding costly mistakes. Securely manage staff and trainee information for complete audit readiness."
                  }
                  title={"Errors & Omissions Analysis"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__nlflX)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/a322737f1ec651e50fcaee6b41573d02.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </div>
              <div
                data-plasmic-name={"row12"}
                data-plasmic-override={overrides.row12}
                className={classNames(projectcss.all, sty.row12)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__t51Dv
                  )}
                  desciption={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "MyQuickPass integration combines geofencing with MyGME Fiscal for accurate trainee activity records. Automatically log clinical hours to ensure accurate data for rigorous Medicare audits."
                      : "MyQuickPass integration combines geofencing with MyGME Fiscal for accurate trainee activity records. Automatically log clinical hours to ensure accurate data for rigorous Medicare audits."
                  }
                  title={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? "MyQuickPass Integration"
                      : "MyQuickPass Integration"
                  }
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___78WVl)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={
                      hasVariant(globalVariants, "mobile", "tabletLandscape")
                        ? {
                            src: "https://site-assets.plasmic.app/2890f4b1e6e8039548a72a55921e66f2.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                        : {
                            src: "https://site-assets.plasmic.app/2890f4b1e6e8039548a72a55921e66f2.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                    }
                  />
                </FeaturesCard>
                <div
                  className={classNames(projectcss.all, sty.freeBox___65FsX)}
                />
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"all3"}
            data-plasmic-override={overrides.all3}
            className={classNames(projectcss.all, sty.all3)}
          >
            <h2
              data-plasmic-name={"title3"}
              data-plasmic-override={overrides.title3}
              className={classNames(
                projectcss.all,
                projectcss.h2,
                projectcss.__wab_text,
                sty.title3
              )}
            >
              {"Full Feature List"}
            </h2>
            <div
              data-plasmic-name={"sections2"}
              data-plasmic-override={overrides.sections2}
              className={classNames(projectcss.all, sty.sections2)}
            >
              <div
                data-plasmic-name={"col3"}
                data-plasmic-override={overrides.col3}
                className={classNames(projectcss.all, sty.col3)}
              >
                <div
                  data-plasmic-name={"list4"}
                  data-plasmic-override={overrides.list4}
                  className={classNames(projectcss.all, sty.list4)}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return [
                          {
                            text: "Billing & Invoicing"
                          },
                          {
                            text: "IRIS/STAR Export"
                          },
                          {
                            text: "Gap and Overlap Analysis"
                          },
                          {
                            text: "FTE Reports & CAP Analysis"
                          },
                          {
                            text: "Audit Management"
                          },
                          {
                            text: "Errors & Omissions Analysis"
                          },
                          {
                            text: "MyQuickPass Integration"
                          }
                        ];
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const currentItem = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <ListItem
                        className={classNames(
                          "__wab_instance",
                          sty.listItem__dTcVv
                        )}
                        key={currentIndex}
                        text={(() => {
                          try {
                            return currentItem.text;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <Icon5Icon
                          className={classNames(projectcss.all, sty.svg__sbYDg)}
                          role={"img"}
                        />
                      </ListItem>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {(hasVariant(globalVariants, "mobile", "mobile") ? true : false) ? (
        <div
          data-plasmic-name={"mobile"}
          data-plasmic-override={overrides.mobile}
          className={classNames(projectcss.all, sty.mobile)}
        >
          <div
            data-plasmic-name={"header3"}
            data-plasmic-override={overrides.header3}
            className={classNames(projectcss.all, sty.header3)}
          >
            <FeaturesProductHeader
              className={classNames(
                "__wab_instance",
                sty.featuresProductHeader__rnQty
              )}
              description={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "MyGME Fiscal uses MyEvaluations data for precise fiscal management, including Medicare reimbursements. Features: Rotation Schedules, Gap Analysis, detailed reports for accurate submissions."
                  : undefined
              }
              subtitle={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "Product"
                  : undefined
              }
            >
              <Logo
                className={classNames("__wab_instance", sty.logo__l0Sm)}
                product={"myGme"}
              />
            </FeaturesProductHeader>
          </div>
          <div
            data-plasmic-name={"key3"}
            data-plasmic-override={overrides.key3}
            className={classNames(projectcss.all, sty.key3)}
          >
            <header
              data-plasmic-name={"header2"}
              data-plasmic-override={overrides.header2}
              className={classNames(projectcss.all, sty.header2)}
            >
              <h2
                className={classNames(
                  projectcss.all,
                  projectcss.h2,
                  projectcss.__wab_text,
                  sty.h2___3Hu8L
                )}
              >
                {"Key Features"}
              </h2>
            </header>
            <div
              data-plasmic-name={"list6"}
              data-plasmic-override={overrides.list6}
              className={classNames(projectcss.all, sty.list6)}
            >
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__vo6Zy
                )}
                desciption={
                  hasVariant(globalVariants, "mobile", "tabletLandscape")
                    ? "Leverage our Reimbursement Dashboard and guided workflows for streamlined fiscal management. Stay financially prepared with ease."
                    : "Leverage our Reimbursement Dashboard and guided workflows for streamlined fiscal management. Stay financially prepared with ease."
                }
                title={
                  hasVariant(globalVariants, "mobile", "tabletLandscape")
                    ? "Reimbursement & Cost Reporting"
                    : "Reimbursement & Cost Reporting"
                }
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__jgPD)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant(globalVariants, "mobile", "mobileXSmall")
                      ? {
                          src: "https://img.plasmic.app/img-optimizer/v1/img/41f0116005941f98fd7ef65b5ee7e865.png",
                          fullWidth: 747,
                          fullHeight: 478
                        }
                      : hasVariant(globalVariants, "mobile", "tabletLandscape")
                        ? {
                            src: "https://site-assets.plasmic.app/f079f25afd226b7eaf59969b4e8413d0.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                        : {
                            src: "https://site-assets.plasmic.app/2b349f46b7ab246ce77422297d6551d7.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                  }
                />

                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__l2YJb)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/41f0116005941f98fd7ef65b5ee7e865.png",
                    fullWidth: 747,
                    fullHeight: 478
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard___5TQtD
                )}
                desciption={
                  hasVariant(globalVariants, "mobile", "tabletLandscape")
                    ? "Streamline reporting processes, ensuring compliance with industry standards. Access tools for precise program assessment and outcome refinement."
                    : "Streamline reporting processes, ensuring compliance with industry standards. Access tools for precise program assessment and outcome refinement."
                }
                title={
                  hasVariant(globalVariants, "mobile", "tabletLandscape")
                    ? "IRIS/STAR Export"
                    : "IRIS/STAR Export"
                }
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img___7PVv)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? {
                          src: "https://site-assets.plasmic.app/27869c919c0c1bf802d79c76d1aaf6b6.svg",
                          fullWidth: 374,
                          fullHeight: 239,
                          aspectRatio: 1.564854
                        }
                      : {
                          src: "https://site-assets.plasmic.app/27869c919c0c1bf802d79c76d1aaf6b6.svg",
                          fullWidth: 374,
                          fullHeight: 239,
                          aspectRatio: 1.564854
                        }
                  }
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__iiiYe
                )}
                desciption={
                  hasVariant(globalVariants, "mobile", "tabletLandscape")
                    ? "Effortlessly generate customized invoices for rotations and services. Simplify program-related expense and revenue management. Ensure transparent financial dealings with stakeholders."
                    : "Effortlessly generate customized invoices for rotations and services. Simplify program-related expense and revenue management. Ensure transparent financial dealings with stakeholders."
                }
                title={
                  hasVariant(globalVariants, "mobile", "tabletLandscape")
                    ? "Billing & Invoicing"
                    : "Billing & Invoicing"
                }
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__iyqSa)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? {
                          src: "https://site-assets.plasmic.app/4ab181866ee0f60493ae5d373a9044df.svg",
                          fullWidth: 374,
                          fullHeight: 239,
                          aspectRatio: 1.564854
                        }
                      : {
                          src: "https://site-assets.plasmic.app/4ab181866ee0f60493ae5d373a9044df.svg",
                          fullWidth: 374,
                          fullHeight: 239,
                          aspectRatio: 1.564854
                        }
                  }
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__bRhPy
                )}
                desciption={
                  "Compare available to actual FTE to improve your bottom line. Support strategic planning for future expansions or contractions. Aid in balancing workload and assignments based on capacity and utilization. "
                }
                title={"FTE Reports & CAP Analysis"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__jyi1W)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/545cfd43ea0c899d900f2bf946291cf3.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__flHle
                )}
                desciption={
                  "Ensure compliance by automating audit trails with integrated schedule details. Streamline the audit process and compliance checks. Reduce manual effort and support program transparency."
                }
                title={"Audit Management"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__ueeYy)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/7e7f7eb8cfd3c607aabaf3c6aef207b6.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__gb6VK
                )}
                desciption={
                  "Simplify personal data import from MyEvaluations, ensuring integrity and avoiding costly mistakes. Securely manage staff and trainee information for complete audit readiness."
                }
                title={"Errors & Omissions Analysis"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img___3AIFh)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/a322737f1ec651e50fcaee6b41573d02.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__ipvSa
                )}
                desciption={
                  hasVariant(globalVariants, "mobile", "tabletLandscape")
                    ? "MyQuickPass integration combines geofencing with MyGME Fiscal for accurate trainee activity records. Automatically log clinical hours to ensure accurate data for rigorous Medicare audits."
                    : "MyQuickPass integration combines geofencing with MyGME Fiscal for accurate trainee activity records. Automatically log clinical hours to ensure accurate data for rigorous Medicare audits."
                }
                title={
                  hasVariant(globalVariants, "mobile", "tabletLandscape")
                    ? "MyQuickPass Integration"
                    : "MyQuickPass Integration"
                }
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__i1BVf)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={
                    hasVariant(globalVariants, "mobile", "tabletLandscape")
                      ? {
                          src: "https://site-assets.plasmic.app/2890f4b1e6e8039548a72a55921e66f2.svg",
                          fullWidth: 374,
                          fullHeight: 239,
                          aspectRatio: 1.564854
                        }
                      : {
                          src: "https://site-assets.plasmic.app/2890f4b1e6e8039548a72a55921e66f2.svg",
                          fullWidth: 374,
                          fullHeight: 239,
                          aspectRatio: 1.564854
                        }
                  }
                />
              </FeaturesCard>
            </div>
          </div>
          <div
            data-plasmic-name={"all2"}
            data-plasmic-override={overrides.all2}
            className={classNames(projectcss.all, sty.all2)}
          >
            <h2
              data-plasmic-name={"title2"}
              data-plasmic-override={overrides.title2}
              className={classNames(
                projectcss.all,
                projectcss.h2,
                projectcss.__wab_text,
                sty.title2
              )}
            >
              {"Full Feature List"}
            </h2>
            <div
              data-plasmic-name={"sections3"}
              data-plasmic-override={overrides.sections3}
              className={classNames(projectcss.all, sty.sections3)}
            >
              <div
                data-plasmic-name={"col4"}
                data-plasmic-override={overrides.col4}
                className={classNames(projectcss.all, sty.col4)}
              >
                <div
                  data-plasmic-name={"list3"}
                  data-plasmic-override={overrides.list3}
                  className={classNames(projectcss.all, sty.list3)}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return [
                          {
                            text: "Billing & Invoicing"
                          },
                          {
                            text: "IRIS/STAR Export"
                          },
                          {
                            text: "Gap and Overlap Analysis"
                          },
                          {
                            text: "FTE Reports & CAP Analysis"
                          },
                          {
                            text: "Audit Management"
                          },
                          {
                            text: "Errors & Omissions Analysis"
                          },
                          {
                            text: "MyQuickPass Integration"
                          }
                        ];
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const currentItem = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <ListItem
                        className={classNames(
                          "__wab_instance",
                          sty.listItem___22AfJ
                        )}
                        key={currentIndex}
                        text={(() => {
                          try {
                            return currentItem.text;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <Icon5Icon
                          className={classNames(projectcss.all, sty.svg__aEdPb)}
                          role={"img"}
                        />
                      </ListItem>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  myEvaluations: [
    "myEvaluations",
    "desktop",
    "row",
    "key2",
    "header",
    "list7",
    "row5",
    "row9",
    "row10",
    "all",
    "title",
    "sections",
    "col2",
    "list2",
    "tablet",
    "row6",
    "key4",
    "header4",
    "list11",
    "row7",
    "row8",
    "row11",
    "row12",
    "all3",
    "title3",
    "sections2",
    "col3",
    "list4",
    "mobile",
    "header3",
    "key3",
    "header2",
    "list6",
    "all2",
    "title2",
    "sections3",
    "col4",
    "list3"
  ],
  desktop: [
    "desktop",
    "row",
    "key2",
    "header",
    "list7",
    "row5",
    "row9",
    "row10",
    "all",
    "title",
    "sections",
    "col2",
    "list2"
  ],
  row: ["row"],
  key2: ["key2", "header", "list7", "row5", "row9", "row10"],
  header: ["header"],
  list7: ["list7", "row5", "row9", "row10"],
  row5: ["row5"],
  row9: ["row9"],
  row10: ["row10"],
  all: ["all", "title", "sections", "col2", "list2"],
  title: ["title"],
  sections: ["sections", "col2", "list2"],
  col2: ["col2", "list2"],
  list2: ["list2"],
  tablet: [
    "tablet",
    "row6",
    "key4",
    "header4",
    "list11",
    "row7",
    "row8",
    "row11",
    "row12",
    "all3",
    "title3",
    "sections2",
    "col3",
    "list4"
  ],
  row6: ["row6"],
  key4: ["key4", "header4", "list11", "row7", "row8", "row11", "row12"],
  header4: ["header4"],
  list11: ["list11", "row7", "row8", "row11", "row12"],
  row7: ["row7"],
  row8: ["row8"],
  row11: ["row11"],
  row12: ["row12"],
  all3: ["all3", "title3", "sections2", "col3", "list4"],
  title3: ["title3"],
  sections2: ["sections2", "col3", "list4"],
  col3: ["col3", "list4"],
  list4: ["list4"],
  mobile: [
    "mobile",
    "header3",
    "key3",
    "header2",
    "list6",
    "all2",
    "title2",
    "sections3",
    "col4",
    "list3"
  ],
  header3: ["header3"],
  key3: ["key3", "header2", "list6"],
  header2: ["header2"],
  list6: ["list6"],
  all2: ["all2", "title2", "sections3", "col4", "list3"],
  title2: ["title2"],
  sections3: ["sections3", "col4", "list3"],
  col4: ["col4", "list3"],
  list3: ["list3"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  myEvaluations: "section";
  desktop: "div";
  row: "div";
  key2: "div";
  header: "header";
  list7: "div";
  row5: "div";
  row9: "div";
  row10: "div";
  all: "div";
  title: "h2";
  sections: "div";
  col2: "div";
  list2: "div";
  tablet: "div";
  row6: "div";
  key4: "div";
  header4: "header";
  list11: "div";
  row7: "div";
  row8: "div";
  row11: "div";
  row12: "div";
  all3: "div";
  title3: "h2";
  sections2: "div";
  col3: "div";
  list4: "div";
  mobile: "div";
  header3: "div";
  key3: "div";
  header2: "header";
  list6: "div";
  all2: "div";
  title2: "h2";
  sections3: "div";
  col4: "div";
  list3: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFeaturesMyGme__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFeaturesMyGme__VariantsArgs;
    args?: PlasmicFeaturesMyGme__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFeaturesMyGme__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFeaturesMyGme__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFeaturesMyGme__ArgProps,
          internalVariantPropNames: PlasmicFeaturesMyGme__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFeaturesMyGme__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "myEvaluations") {
    func.displayName = "PlasmicFeaturesMyGme";
  } else {
    func.displayName = `PlasmicFeaturesMyGme.${nodeName}`;
  }
  return func;
}

export const PlasmicFeaturesMyGme = Object.assign(
  // Top-level PlasmicFeaturesMyGme renders the root element
  makeNodeComponent("myEvaluations"),
  {
    // Helper components rendering sub-elements
    desktop: makeNodeComponent("desktop"),
    row: makeNodeComponent("row"),
    key2: makeNodeComponent("key2"),
    header: makeNodeComponent("header"),
    list7: makeNodeComponent("list7"),
    row5: makeNodeComponent("row5"),
    row9: makeNodeComponent("row9"),
    row10: makeNodeComponent("row10"),
    all: makeNodeComponent("all"),
    title: makeNodeComponent("title"),
    sections: makeNodeComponent("sections"),
    col2: makeNodeComponent("col2"),
    list2: makeNodeComponent("list2"),
    tablet: makeNodeComponent("tablet"),
    row6: makeNodeComponent("row6"),
    key4: makeNodeComponent("key4"),
    header4: makeNodeComponent("header4"),
    list11: makeNodeComponent("list11"),
    row7: makeNodeComponent("row7"),
    row8: makeNodeComponent("row8"),
    row11: makeNodeComponent("row11"),
    row12: makeNodeComponent("row12"),
    all3: makeNodeComponent("all3"),
    title3: makeNodeComponent("title3"),
    sections2: makeNodeComponent("sections2"),
    col3: makeNodeComponent("col3"),
    list4: makeNodeComponent("list4"),
    mobile: makeNodeComponent("mobile"),
    header3: makeNodeComponent("header3"),
    key3: makeNodeComponent("key3"),
    header2: makeNodeComponent("header2"),
    list6: makeNodeComponent("list6"),
    all2: makeNodeComponent("all2"),
    title2: makeNodeComponent("title2"),
    sections3: makeNodeComponent("sections3"),
    col4: makeNodeComponent("col4"),
    list3: makeNodeComponent("list3"),

    // Metadata about props expected for PlasmicFeaturesMyGme
    internalVariantProps: PlasmicFeaturesMyGme__VariantProps,
    internalArgProps: PlasmicFeaturesMyGme__ArgProps
  }
);

export default PlasmicFeaturesMyGme;
/* prettier-ignore-end */
